import { Roles } from "./Enums";

export abstract class UserWithRole {
  public userId: number;
  public role: Roles;
  public isAdmin: boolean;
  public isCountryAdmin: boolean;
  public isAdminGroupProfile: boolean;
  public isUserGroupProfile: boolean;
  public isCountryGroupProfile: boolean;
  public isCountryUser: boolean;
  public isDistributor: boolean;
  public isIndirectCustomer: boolean;
  public isUser: boolean;

  protected setUserRole(): void {
    this.isAdmin = Roles.Admin == this.role;
    this.isCountryAdmin = Roles.CountryAdmin == this.role;
    this.isAdminGroupProfile = [Roles.Admin, Roles.CountryAdmin].includes(this.role);
    this.isCountryGroupProfile = [Roles.CountryAdmin, Roles.CountryUser].includes(this.role);
    this.isCountryUser = Roles.CountryUser == this.role;
    this.isDistributor = Roles.Distributor == this.role;
    this.isIndirectCustomer = Roles.IndirectCustomer == this.role;
    this.isUser = Roles.User == this.role;
    this.isUserGroupProfile = [Roles.User, Roles.Distributor, Roles.IndirectCustomer].includes(
      this.role,
    );
  }
}
